import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const MULTIBANCO_REFERENCE: PaymentMethod = {
    id: PAYMENT_METHOD_ID.MultibancoReference,
    name: 'multibancoreference',
    displayName: 'MULTIBANCO_REFERENCE'
};
